import { render, staticRenderFns } from "./world-coverage.vue?vue&type=template&id=08cdb180&"
import script from "./world-coverage.vue?vue&type=script&lang=js&"
export * from "./world-coverage.vue?vue&type=script&lang=js&"
import style0 from "./world-coverage.vue?vue&type=style&index=0&id=08cdb180&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports